export function getToken() {
    return localStorage.getItem("access_token");
  }
  
  function decodePayload(token) {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
      return JSON.parse(jsonPayload);
    } catch {
      return null;
    }
  }
  
  export function getClaims() {
    const t = getToken();
    if (!t) return null;
    return decodePayload(t);
  }
  
  export function isAdmin() {
    const c = getClaims();
    return !!(c && c.is_admin);
  }
  
  export function isImpersonating() {
    const c = getClaims();
    return !!(c && c.impersonated_by);
  }
  
  export function whoAmI() {
    const c = getClaims();
    if (!c) return null;
    return {
      email: c.sub || null,        // Flask-JWT-Extended puts identity in "sub"
      is_admin: !!c.is_admin,
      impersonated_by: c.impersonated_by || null,
      organization_id: c.organization_id || null,
    };
  }
  